<template>
    <c-dialog ref="dialog" height="380" width="500" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-tips v-if="this.account_type == 4 || this.account_type == 5">{{tipWords}}</c-tips>
            <c-form-item label="充值金额" required>
                <c-radio-group v-model="rechargeMoneyType" :options="rechargeMoneyOptions" :clear="false">
                </c-radio-group>
            </c-form-item>
            <c-form-item label="自定义充值金额" required v-show="rechargeMoneyType == 0" :disabled="rechargeMoneyType > 0">
                <c-input type="number" name="recharge_money" v-model="rechargeMoney" decimal="0" :range="[1, 999999]" append-text="元"
                         placeholder="请输入自定义充值金额" style="flex: 1;"></c-input>
            </c-form-item>
            <c-form-item label="打款凭证" required>
                <c-upload-file filePath="quote" name="voucher_url" v-model="payVoucherUrl" type="image"></c-upload-file>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'pointsRecharge',

    components: {
    },
    props: {
        account_type: Number        //充值账户类型
    },

    data() {
        return {
            account:{},
            isCustom:0,             //是否自定义充值 1=自定义
            rechargeMoney:0,
            rechargeMoneyType:0,
            rechargeMoneyOptions: [],
            rechargeRatio:1,        //充值比例（10表示1元换10积分）
            payVoucherUrl:'',       //支付凭证
            tipWords:''             //提示信息
        }
    },

    computed: {
        ...mapState(['systemConfig','saasInfo']),
    },

    watch:{
        rechargeMoneyType(){
            if (this.rechargeMoneyType > 0){
                this.rechargeMoney = this.rechargeMoneyType;
            } else {
                this.rechargeMoney = '';    //切回自定义时清空预设金额
            }
        }
    },
    methods: {
        /**
         * 加载账户余额信息
         */
        loadAccount() {
            this.request({
                url: '/sys_saas/account/info',
                data: {
                    account_type:this.account_type
                },
                loading: false,  // 是否显示loading，
                success: data => {
                    this.account = data;
                    this.rechargeRatio = data.ratio||1;
                    this.rechargeMoneyOptions = data.recharge_money_list;
                    if (this.rechargeMoneyOptions && this.rechargeMoneyOptions.length > 0){
                        this.rechargeMoneyType = this.rechargeMoneyOptions[0].value;
                    }
                    this.tipWords = '1元等于'+this.rechargeRatio+'个积分，充值申请审核通过后即可到账';
                }
            });
        },
        /*********打开编辑框，初始化**********/
        open() {
            //加载账号详情
            this.loadAccount();
            //拼接提示文案
            var title = "渠道积分充值/扣减";
            if (this.account_type == 4){
                title = "【渠道同售积分】充值";
            }else if(this.account_type  == 5){
                title = "【IME查询积分】充值";
                this.tipWords = '';
            }else if(this.account_type  == 3){
                title = "【保证金】充值";
            }
            this.$refs.form.clear();
            //填充form表单
            this.$refs.dialog.open({
                title: title
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            if (this.rechargeMoney <= 0){
                this.$message({
                    message: '请选择或填写充值金额',  // 提示内容,
                    type: 'warn'
                });
                return false;
            }
            if (!this.payVoucherUrl || this.payVoucherUrl == ''){
                this.$message({
                    message: '请上传支付凭证',  // 提示内容,
                    type: 'warn'
                });
                return false;
            }
            this.request({
                url: '/account/recharge',
                data: {
                    account_type:this.account_type,
                    recharge_money:this.rechargeMoney,
                    voucher_url:this.payVoucherUrl,
                },
                loading: true,
                success: () => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>